/**
 * Utility function to get a random element from an array
 * @param {Array} arr - The array to select from
 * @returns {*} A random element from the array
 */
export function getRandomElement(arr) {
    if (!arr || arr.length === 0) {
        console.warn('getRandomElement: received empty or invalid array');
        return null;
    }
    return arr[Math.floor(Math.random() * arr.length)];
}

/**
 * Creates a stateful random selector that avoids recent selections
 * @param {number} maxRecent - Maximum number of recent selections to avoid
 * @returns {Function} A selector function
 */
export function createRandomSelector(maxRecent = 5) {
    let recentSelections = [];
    
    return function getRandomElementWithoutRepeats(arr) {
        if (!arr || arr.length === 0) {
            console.warn('getRandomElementWithoutRepeats: received empty or invalid array');
            return null;
        }
        
        // If we have fewer items than our repeat buffer, just use normal random
        if (arr.length <= maxRecent) {
            return getRandomElement(arr);
        }
        
        // Filter out recently selected items and keep track of their original indexes
        let availableIndexes = [];
        for (let i = 0; i < arr.length; i++) {
            if (!recentSelections.includes(i)) {
                availableIndexes.push(i);
            }
        }
        
        // If we've somehow excluded everything, reset and try again
        if (availableIndexes.length === 0) {
            recentSelections = [];
            availableIndexes = Array.from({length: arr.length}, (_, i) => i);
        }
        
        // Select a random index from available indexes
        const selectedIndex = getRandomElement(availableIndexes);
        const selectedItem = arr[selectedIndex];
        
        // Track this selection
        recentSelections.push(selectedIndex);
        
        // Keep only the most recent selections
        if (recentSelections.length > maxRecent) {
            recentSelections.shift();
        }
        
        return selectedItem;
    };
}

// Create a default instance for the app
export const getRandomElementWithoutRepeats = createRandomSelector(5);